import { render, staticRenderFns } from "./ExpedicaoCargaForm.vue?vue&type=template&id=35315603"
import script from "./ExpedicaoCargaForm.vue?vue&type=script&lang=js"
export * from "./ExpedicaoCargaForm.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoCargaForm.vue?vue&type=style&index=0&id=35315603&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports